module.exports = __webpack_public_path__ + "img/fdaa855.jpg";